class FaroUtil {
  static faroInstance;
  constructor(props) {

  }

  initialize() { }
    
}

export default FaroUtil;

export const getIsFaroEnabled = () => {

};

export function sendFaroLog(payload) {

}
